export default __webpack_public_path__ + "static/media/password 1.3e3c04d6.svg";